
import BaseTask from 'models/BaseTask'

export default class Task extends BaseTask {

  // アクセサ: 検索用キー値を取得
  static key(storeCode, floorCode, taskCode) {
    if(storeCode instanceof Object) {
      floorCode = storeCode.floor_code
      taskCode  = storeCode.task_code
      storeCode = storeCode.store_code
    }
    return storeCode + '/' + floorCode + '/' + taskCode
  }
}
